import { createSelector } from "reselect";
import { selectCanUseProjects } from "../state/config/config.selector";
import type { AppState } from "../state/root.reducer";
import type { MyWorkspaceMetadata } from "../state/workspaces/types";
import { selectHasAssignableProjects } from "../state/workspaces/workspaces.selector";

export const selectCanAssignProjectToWorkspace = createSelector(
  [
    selectCanUseProjects,
    selectHasAssignableProjects,
    (_: AppState, myWorkspaceMetadata?: MyWorkspaceMetadata) =>
      myWorkspaceMetadata,
  ],
  (canUseProjects, hasAssignableProjects, myWorkspaceMetadata) =>
    canUseProjects &&
    hasAssignableProjects &&
    !myWorkspaceMetadata?.containerId &&
    !!myWorkspaceMetadata?.myPermissions.canAdmin,
);
